export default "__VITE_ASSET__70babf29__"